<div class="icon-avatar">
    <img src="{{ avatar$ | async }}" />
</div>
